import React, { Component } from "react";
import User from "./roleRouters/User";
import "normalize.css";
import "./App.css";
import { Route, Switch } from "react-router-dom";

class App extends Component {
  render() {
    return (
      <Switch>
        <Route path="/" component={User} />
      </Switch>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js